import { Store } from '@toeverything/infra';
import { map, Observable } from 'rxjs';

import type { WorkspaceDBService } from '../../db';

/**
 * Store for tracking Meetings database documents.
 * Persists meetings doc IDs to the workspace database.
 */
export class MeetingsStore extends Store {
  constructor(private readonly dbService: WorkspaceDBService) {
    super();
  }

  /**
   * Check if a doc is a Meetings database
   */
  isMeetingsDoc(docId: string): boolean {
    const result = this.dbService.db.docProperties.find({
      id: docId,
    });
    return result[0]?.isMeetingsDb === true;
  }

  /**
   * Get all Meetings doc IDs
   */
  getMeetingsDocIds(): string[] {
    return this.dbService.db.docProperties
      .find({ isMeetingsDb: true })
      .map(property => property.id);
  }

  /**
   * Watch for changes to the meetings database docs list
   */
  watchMeetingsDocs(): Observable<string[]> {
    return this.dbService.db.docProperties
      .find$({ isMeetingsDb: true })
      .pipe(map(docs => docs.map(d => d.id)));
  }

  /**
   * Get all individual meeting doc IDs (not the database)
   */
  getMeetingDocIds(): string[] {
    return this.dbService.db.docProperties
      .find({ isMeetingDoc: true })
      .map(property => property.id);
  }

  /**
   * Watch for changes to individual meeting docs
   */
  watchMeetingDocs(): Observable<string[]> {
    return this.dbService.db.docProperties
      .find$({ isMeetingDoc: true })
      .pipe(map(docs => docs.map(d => d.id)));
  }
}
